module.exports = __webpack_public_path__ + "img/regular.26a673b9.png";